// @ts-strict-ignore
import clsx from 'clsx'
import Image from 'next/image'
import { FC } from 'react'

import Tip from '@/screens/Credit/page/ui/Tip/Tip'

import { Question } from '@/shared/lib/@deprecated/iport-icons'

import { NoteList } from '../NoteList/NoteList'
import { gridItemProps } from '../styles'

import cl from './TableItem.module.scss'

export const TableItem: FC<gridItemProps> = ({ name, logo, price, time, nodeList, insuranceSum }) => {
	return (
		<>
			<Image src={logo.imgSRC} height={logo.height} width={logo.width} alt={name.title} />
			<div className={cl.container}>
				<div className={cl.top}>
					<div className={cl.textWrapper}>
						<h4 className={cl.rowTitle}>
							{name.title}
							{name.titleNotation && (
								<Tip tooltipPosition={'topLeft'} Icon={<Question size={24} className={cl.icon} />}>
									<span className={cl.titleNotation}>{name.titleNotation}</span>
								</Tip>
							)}
						</h4>
						<p className={cl.rowSubtitle}>{name.subtitle}</p>
					</div>
					<ul className={cl.list}>
						<li className={clsx(cl.item, cl.textWrapper)}>
							<h4 className={cl.colTitle}>{time.title}</h4>
							<p className={cl.colSubtitle}>
								{time.subtitle}
								{time.subtitleNotation && (
									<Tip tooltipPosition={'topLeft'} Icon={<Question size={24} className={cl.icon} />}>
										<span className={cl.titleNotation}>{time.subtitleNotation}</span>
									</Tip>
								)}
							</p>
						</li>
						<li className={clsx(cl.item, cl.textWrapper)}>
							<h4 className={cl.colTitle}>{insuranceSum.title}</h4>
							<p className={cl.colSubtitle}>{insuranceSum.subtitle}</p>
						</li>
						<li className={clsx(cl.item, cl.textWrapper)}>
							<h4 className={cl.colTitle}>{price.title}</h4>
							<p className={cl.colSubtitle}>{price.subtitle}</p>
						</li>
					</ul>
				</div>
				<NoteList data={nodeList} />
			</div>
		</>
	)
}
